import React from 'react'
import { Link } from 'react-router-dom'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import util from 'meinian-package/src/utils/util'
import { useRouterPage } from '../../../home/common'
import styles from './index.module.less'

export default () => {
  const ROUTES = useRouterPage()
  return <div className={styles.asideRouterCard}>
    {ROUTES.map(link => <Link
      to={link.value + (link.query || '')}
    >

      <div
        className={classNames('asideRouterCardItem', { active: location.pathname.includes(`/meinian${link.value}`) })}
        onClick={() => {
          if ((link.name || link.label) !== '智能选款') {
            util.track('mn-header-link', {
              module1: '侧边栏',
              module2: link.name || link.label
            })
          }
        }}
      >
        <div><Icon type={link.icon} className="asideRouterCardItemIcon" /></div>
        <div className="asideRouterCardItemText">{link.label}</div>
      </div>
    </Link>)}
  </div>
}
